<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="pull-left img-back" href="javascript:window.history.go(-1)" >返回</a>
        <h1>{{studentName}}的作业</h1>
      </div>
      <div class="liner"></div>
    </div>

    <mt-loadmore :top-method="loadTop" ref="loadmore">
    <div class="main-page homework"
    v-infinite-scroll="loadBottom"
    infinite-scroll-disabled="isGetting"
    infinite-scroll-distance="150">
      <div v-for="item in homeworkList">
        <div class="padding-15 teacher" v-bind:class="{'teacher' : item.clientType == 'teacher', parents : item.clientType == 'parents'}" >
          <div class="clearfix">
            <div class="header-pic">
              <a class="block">
                <span class="img-wrap small block"><img :src="item.userImage ? baseAcessPath + item.userImage : img_default" /></span>
              </a>
            </div>
            <div class="content">
              <span class="who">{{item.userName + (item.clientType == 'teacher' ? '【 老师 】' : '')}} -&nbsp;&nbsp;&nbsp;{{item.publishDate | dateDiff}}</span>
              <div class="wrap">
                <i></i>
                <cite v-if="item.field1 == '0'"></cite>
                <router-link :to="{path: '/homework/detail/' + item.homeWorkId}">{{item.content}}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="homeworkList == 0" class="text-center" style="padding-top:200px">暂无作业</div>
    </div>
    </mt-loadmore>
  </div>
</template>

<script>
import { service } from '../../service'
import { mapGetters, mapMutations } from 'vuex'

export default {
  computed: mapGetters({
    vuexHomework: 'vuexHomework'
  }),
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      curcheId: 0,
      teacherId: 0,
      get_student_homework_list_para: service.setPara('getStudentHomeWorkList'),
      homeworkList: [],
      baseAcessPath: '',
      isGetting: false,
      isOver: false,
      studentId: 0,
      studentName: '',
      offset: 0
    }
  },
  mounted: function () {
    this.studentId = this.$route.params.studentId
    this.studentName = this.$route.params.studentName

    this.curcheId = this.cookie_login_data.curcheId
    this.teacherId = this.cookie_login_data.teacherId
    this.baseAcessPath = this.cookie_login_data.baseAcessPath

    this.get_student_homework_list_para.curcheId = this.curcheId
    this.get_student_homework_list_para.userId = this.teacherId
    this.get_student_homework_list_para.studentId = this.studentId
    this.get_student_homework_list_para.offset = this.offset

    let flag = true
    let obj = this.vuexHomework.stuAll
    if (this.vuexHomework.stuFlag) {
      if ((new Date().getTime() - this.vuexHomework.stuTime) < 300 * 1000 && obj.para.curcheId == this.curcheId && obj.para.teacherId == this.teacherId && obj.para.studentId == this.studentId) { // 5分钟刷一下
        this.get_student_homework_list_para.offset = obj.para.offset
        this.isOver = obj.isOver
        let jsonStr = JSON.stringify(obj.list)
        this.homeworkList = JSON.parse(jsonStr)
        flag = false
      }
    }
    if (flag) {
      this.get_student_homework_list_para.offset = this.offset
      this.getStudentHomeWorkList()
    }
  },
  methods: {
    ...mapMutations([
      'receiveStudentHomeworkList'
    ]),
    loadTop (id) {
      this.homeworkList = []
      this.get_student_homework_list_para.offset = 0
      this.getStudentHomeWorkList()
      this.$refs.loadmore.onTopLoaded(id)
    },
    loadBottom () {
      if (this.isOver || this.isGetting) {
        return
      }
      this.offset++
      this.get_student_homework_list_para.offset = this.offset
      this.getStudentHomeWorkList()
    },
    getStudentHomeWorkList: function () { // 获取作业列表
      this.isGetting = true

      let obj = {context: this, para: this.get_student_homework_list_para, isIndicator: false, successFun: (response) => {
        this.isGetting = false
        if (response.data.list.length == 0) {
          this.isOver = true
        } else {
          this.homeworkList = this.homeworkList.concat(response.data.list)
        }
      }}
      service.request(obj)
    }
  },
  beforeDestroy: function () {
    let obj = {}
    // obj.scrollTop = this.scrollTop
    obj.list = this.homeworkList
    obj.isOver = this.isOver
    obj.offset = this.offset
    obj.para = this.get_student_homework_list_para
    this.$store.dispatch('receiveStudentHomeworkList', obj)
  }
}
</script>
<style scoped>
  .main-page{padding-bottom:45px;}
</style>


// WEBPACK FOOTER //
// homeworkStudent.vue?cc936e9c